// extracted by mini-css-extract-plugin
export default {"tagList":"tagList_VDGI6","listType":"listType_EaAG2","title":"title_vzuEp","listBox":"listBox_P0L2u","tagItem":"tagItem_A08Bx","action":"action_mckGL","footer":"footer_NdKNp"};